import {Pipe, PipeTransform} from '@angular/core';
import {ClientBankAccountResponseBasic} from 'src/app/dashboard/models/bankAccount.model';
import {ResourceService} from 'src/app/services/resource.service';

@Pipe({name: 'bankAccountDisplayName', pure: true})
export class BankAccountDisplayName implements PipeTransform {
  transform(value: ClientBankAccountResponseBasic, withCountryCode: boolean) {
    if (!value) {
      return '';
    }

    let displayName = value.nickname;
    if (!value.nickname) {
      displayName = value.holderFullName;
    }

    if (withCountryCode && value.country && value.country.code) {
      displayName = `${displayName} (${value.country.code})`;
    }
    return displayName;
  }

  constructor(private resourceService: ResourceService) {
  }
}
